import { OuraSymbolIcon } from '@jouzen/ecom-components/icons/OuraSymbolIcon';
import { BodyLink } from '@jouzen/ecom-components/v3/BodyLink';
import type { TypographyProps } from '@jouzen/ecom-components/v3/Typography';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import type { RichTranslationValues } from 'next-intl';
import type { ReactNode } from 'react';

const getValues = (options?: {
  li?: Omit<TypographyProps, 'children'>;
}): RichTranslationValues => {
  return {
    li: function li(chunks: ReactNode) {
      return (
        <Typography variant="h5" Element="li" className="mb-2" {...options?.li}>
          {chunks}
        </Typography>
      );
    },

    GfcuLink: function GfcuLink(chunks: ReactNode) {
      return (
        <BodyLink href="/guidelines-for-commercial-use">{chunks}</BodyLink>
      );
    },
    symbol: function symbol() {
      return <OuraSymbolIcon className="inline" />;
    },
  };
};

export default getValues;
